// deno-fmt-ignore-file
export function FromNull(context, type) {
    return null;
}
